export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7098799f56239287ee14bd8d1c14ea0fa0c6a0ba86&name=pushAdClickData!'